import React from 'react';
import { Settings } from '@pascal/pascal-core/table-line';

export function SettingsContainer() {
  return <Settings />;
}
